"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCalculatorValues = void 0;
const setCalculatorValues = function (el, data, normal) {
    var _a;
    var coin_el = el.find(".arz-input-coin-value"), usd_el = el.find(".arz-input-coin-usd"), tomans_el = el.find(".arz-input-coin-tomans"), val, type = data.type, coin, usd, tomans, status = false, postfix = '', $p_type = '';
    if (typeof data == 'number' || typeof data == 'string') {
        data = { val: data };
        type = 'coin';
    }
    if (data.val) {
        if (data.val && data.val.length > 1 && data.val.endsWith('.')) {
            $p_type = (_a = data.type) !== null && _a !== void 0 ? _a : '';
            postfix = '.';
        }
        if (typeof data.val == 'string') {
            val = data.val.replace(/,/g, '');
        }
        else if (!data.type) {
            val = data.val;
            type = 'coin';
        }
    }
    if (val == '.') {
        status = false;
    }
    else if (val == '') {
        el.find('input').val('');
    }
    else if (type == 'coin') {
        coin = Number(val);
        if (coin) {
            usd = coin * el.data("usd");
            tomans = usd * el.data("sana");
            status = true;
        }
    }
    else if (type == 'usd') {
        usd = Number(val);
        if (usd) {
            coin = usd / el.data("usd");
            tomans = usd * el.data("sana");
            status = true;
        }
    }
    else if (type == 'tomans') {
        tomans = Number(val);
        if (tomans) {
            usd = tomans / el.data("sana");
            coin = usd / el.data("usd");
            status = true;
        }
    }
    if (status) {
        coin_el.data("value", coin !== null && coin !== void 0 ? coin : null);
        usd_el.data("value", usd !== null && usd !== void 0 ? usd : null);
        tomans_el.data("value", tomans !== null && tomans !== void 0 ? tomans : null);
        if (normal) {
            coin = arzDigital.normalizeDecimal(coin);
            usd = arzDigital.normalizeDecimal(usd);
        }
        if ($p_type == 'coin' || $p_type == '')
            coin += postfix;
        if ($p_type == 'usd')
            usd += postfix;
        if ($p_type == 'tomans')
            tomans += postfix;
        coin_el.val(isFinite(coin.toString().replaceAll(",", "")) ? coin : 0);
        usd_el.val(isFinite(usd.toString().replaceAll(",", "")) ? usd : 0);
        tomans_el.val(isFinite(+tomans) ? arzDigital.normalizeDecimal(tomans) : 0);
    }
};
exports.setCalculatorValues = setCalculatorValues;
